var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    d: "M16 5.6875L16.5303 6.21783L17.0607 5.6875L16.5303 5.15717L16 5.6875ZM11.3125 16.75C11.7267 16.75 12.0625 16.4142 12.0625 16C12.0625 15.5858 11.7267 15.25 11.3125 15.25L11.3125 16.75ZM11.8428 10.9053L16.5303 6.21783L15.4697 5.15717L10.7822 9.84467L11.8428 10.9053ZM16.5303 5.15717L11.8428 0.46967L10.7822 1.53033L15.4697 6.21783L16.5303 5.15717ZM16 4.9375L6.15625 4.9375L6.15625 6.4375L16 6.4375L16 4.9375ZM6.15625 16.75L11.3125 16.75L11.3125 15.25L6.15625 15.25L6.15625 16.75ZM0.25 10.8437C0.25 14.1057 2.89432 16.75 6.15625 16.75L6.15625 15.25C3.72275 15.25 1.75 13.2773 1.75 10.8437L0.25 10.8437ZM6.15625 4.9375C2.89432 4.9375 0.250001 7.58182 0.25 10.8437L1.75 10.8437C1.75 8.41024 3.72275 6.4375 6.15625 6.4375L6.15625 4.9375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedo);
export default __webpack_public_path__ + "static/media/redo.aed14c19d34c984e2fa417629514f876.svg";
export { ForwardRef as ReactComponent };